<template>
<div id="invoice-page">
    <div class="main-container" >
        <router-view></router-view>
		<!-- Navbar section -->
		<HeaderSoftware />

        <!-- breadcrumb strat -->
    <Breadcrumb>
      <template slot="breadcrumb">
        <div class="breadcrumb_box text-center">
          <h2 class="breadcrumb-title">{{$t('shop')}}</h2>
          <!-- breadcrumb-list start -->
          <ul class="breadcrumb-list">
            <li class="breadcrumb-item">
              <router-link :to="{name:'HomeBranding'}">{{$t('home')}}</router-link>
            </li>
            <li class="breadcrumb-item active">{{$t('shop')}}</li>
            <li class="breadcrumb-item">
              <router-link :to="{name:'checkout'}">{{$t('checkout')}}</router-link>
            </li>
          </ul>
          <!-- breadcrumb-list end -->
        </div>
      </template>
    </Breadcrumb>
    <!-- breadcrumb end -->
        <div class="container" >
                <div class="row  full-height">
                    <div class="col-md-12 text-center" >
                      
                      

                        <div class="error-image section-space--mb_50" id="invoice-container">
                          
                            <p class="item-description text-sm" v-html="sMail" style="white-space: pre-line;width:100%;height:100%"></p>
                            
                        </div>
                        
                        <!-- <h1 class="error-404-title font-weight--light text-white"> Oops! Sayfa Bulunamadı!</h1> -->
                        <div class="error-buttons section-space--mt_50">
                            <vs-button  class="ht-btn ht-btn-md text-center" icon-pack="feather" icon="icon icon-printer" @click="printInvoice" style="margin: auto;width: 15%;padding: 0px;">Print</vs-button>                          
                            <router-link class="ht-btn ht-btn-md" to="/">
                                <span class="button-icon mr-2">
                                    <i class="fa fa-home"></i>
                                </span>
                                <span class="button-text">{{$t('home')}}</span>
                                
                            </router-link>
                            
                            
                        </div>
                    </div>
                </div>
            </div>
         <!-- footer section -->
        <FooterMain />

        <!-- offcanvas search component -->
        <OffcanvasSearchBox />

        <!-- off-canvas mobile menu -->
        <OffCanvasMobileMenu />
    </div>
    </div>
</template>
<script>
import HeaderSoftware from "../components/HeaderSoftware";
import Breadcrumb from '@/components/Breadcrumb'
import FooterMain from '@/components/FooterMain'
import OffcanvasSearchBox from '@/components/OffcanvasSearchBox'
    import OffCanvasMobileMenu from '@/components/OffCanvasMobileMenu'
export default {
    data () {
     return {
      sMail:""     
    }
    },
     components: {
     HeaderSoftware,
     Breadcrumb,
     FooterMain,
     OffcanvasSearchBox,
     OffCanvasMobileMenu
     },
     created(){
       this.sMail = localStorage.getItem("sMail");
     },
     methods:{
      printInvoice () {
      window.print()
      }
     },
     mounted () {
    this.$emit('setAppClasses', 'invoice-page')
  }
     
}
</script>
<style lang="scss">
@media print {
  
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
      font-size: 8px;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top:0;
      right: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
  //size: 84.1cm 59.4cm;margin: 1cm 1cm 1cm 1cm;
}
</style>

